export const formatGovRegCode = (govRegCode?: string) => {
  if (!govRegCode) return '-'
  govRegCode = govRegCode.replace(/\D/g, '')
  return govRegCode.length > 11
    ? govRegCode.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
    : govRegCode.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
}
